"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/web.timers.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.parse-int.js");

var _checkbox = _interopRequireDefault(require("element-ui/lib/checkbox"));

var _checkboxGroup = _interopRequireDefault(require("element-ui/lib/checkbox-group"));

var _scrollbar = _interopRequireDefault(require("element-ui/lib/scrollbar"));

var _locale = _interopRequireDefault(require("element-ui/lib/mixins/locale"));

var _clickoutside = _interopRequireDefault(require("element-ui/lib/utils/clickoutside"));

var _popup = require("element-ui/lib/utils/popup");

var _vuePopper = _interopRequireDefault(require("element-ui/lib/utils/vue-popper"));

var _dropdown = _interopRequireDefault(require("./dropdown"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_vm.multiple ? _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: _vm.handleOutsideClick,
      expression: "handleOutsideClick"
    }, {
      name: "show",
      rawName: "v-show",
      value: _vm.showPopper,
      expression: "showPopper"
    }],
    staticClass: "el-table-filter",
    attrs: {}
  }, [_c('div', {
    staticClass: "el-table-filter__content",
    attrs: {}
  }, [_c('el-scrollbar', {
    attrs: {
      "wrap-class": "el-table-filter__wrap"
    }
  }, [_c('el-checkbox-group', {
    staticClass: "el-table-filter__checkbox-group",
    attrs: {},
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: _vm.filteredValue,
      callback: function callback($v) {
        _vm.filteredValue = $v;
      },
      expression: "filteredValue"
    }
  }, _vm._l(_vm.filters, function (filter) {
    return _c('el-checkbox', {
      key: filter.value,
      attrs: {
        "label": filter.value
      }
    }, [_vm._v(_vm._s(filter.text))]);
  }))], 1)], 1), _vm._v(" "), _vm.showFooter ? _c('div', {
    staticClass: "el-table-filter__bottom",
    attrs: {}
  }, [_c('button', {
    "class": {
      'is-disabled': _vm.filteredValue.length === 0
    },
    attrs: {
      "disabled": _vm.filteredValue.length === 0
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('el.table.confirmFilter')) + "\n      ")]), _vm._v(" "), _c('button', {
    attrs: {},
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('el.table.resetFilter')))])]) : _vm._e()]) : _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: _vm.handleOutsideClick,
      expression: "handleOutsideClick"
    }, {
      name: "show",
      rawName: "v-show",
      value: _vm.showPopper,
      expression: "showPopper"
    }],
    staticClass: "el-table-filter",
    attrs: {}
  }, [_c('ul', {
    staticClass: "el-table-filter__list",
    attrs: {}
  }, [_c('li', {
    staticClass: "el-table-filter__list-item",
    "class": {
      'is-active': _vm.filterValue === undefined || _vm.filterValue === null
    },
    attrs: {},
    on: {
      "click": function click($event) {
        _vm.handleSelect(null);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.t('el.table.clearFilter')) + "\n      ")]), _vm._v(" "), _vm._l(_vm.filters, function (filter) {
    return _c('li', {
      key: filter.value,
      staticClass: "el-table-filter__list-item",
      "class": {
        'is-active': _vm.isActive(filter)
      },
      attrs: {
        "label": filter.value
      },
      on: {
        "click": function click($event) {
          _vm.handleSelect(filter.value);
        }
      }
    }, [_vm._v("\n        " + _vm._s(filter.text) + "\n      ")]);
  })], 2)])]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElTableFilterPanel',
  mixins: [_vuePopper["default"], _locale["default"]],
  directives: {
    Clickoutside: _clickoutside["default"]
  },
  components: {
    ElCheckbox: _checkbox["default"],
    ElCheckboxGroup: _checkboxGroup["default"],
    ElScrollbar: _scrollbar["default"]
  },
  props: {
    placement: {
      type: String,
      "default": 'bottom-end'
    }
  },
  customRender: function customRender(h) {
    var _vm = this;

    return h("div", {
      "class": "el-table-filter"
    }, [h("div", {
      "class": "el-table-filter__content"
    }), h("div", {
      "class": "el-table-filter__bottom"
    }, [h("button", {
      "on": {
        "click": this.handleConfirm
      }
    }, [this.t('el.table.confirmFilter')]), h("button", {
      "on": {
        "click": this.handleReset
      }
    }, [this.t('el.table.resetFilter')])])]);
  },
  methods: {
    isActive: function isActive(filter) {
      return filter.value === this.filterValue;
    },
    handleOutsideClick: function handleOutsideClick() {
      var _this = this;

      setTimeout(function () {
        _this.showPopper = false;
      }, 16);
    },
    handleConfirm: function handleConfirm() {
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleChange: function handleChange() {
      if (this.showFooter) return;
      this.confirmFilter(this.filteredValue);
    },
    handleReset: function handleReset() {
      this.filteredValue = [];
      this.confirmFilter(this.filteredValue);
      this.handleOutsideClick();
    },
    handleSelect: function handleSelect(filterValue) {
      this.filterValue = filterValue;

      if (typeof filterValue !== 'undefined' && filterValue !== null) {
        this.confirmFilter(this.filteredValue);
      } else {
        this.confirmFilter([]);
      }

      this.handleOutsideClick();
    },
    confirmFilter: function confirmFilter(filteredValue) {
      this.table.store.commit('filterChange', {
        column: this.column,
        values: filteredValue
      });
      this.table.store.updateAllSelected();
    }
  },
  data: function data() {
    return {
      table: null,
      cell: null,
      column: null
    };
  },
  computed: {
    filters: function filters() {
      return this.column && this.column.filters;
    },
    filterValue: {
      get: function get() {
        return (this.column.filteredValue || [])[0];
      },
      set: function set(value) {
        if (this.filteredValue) {
          if (typeof value !== 'undefined' && value !== null) {
            this.filteredValue.splice(0, 1, value);
          } else {
            this.filteredValue.splice(0, 1);
          }
        }
      }
    },
    filteredValue: {
      get: function get() {
        if (this.column) {
          return this.column.filteredValue || [];
        }

        return [];
      },
      set: function set(value) {
        if (this.column) {
          this.column.filteredValue = value;
        }
      }
    },
    multiple: function multiple() {
      if (this.column) {
        return this.column.filterMultiple;
      }

      return true;
    },
    showFooter: function showFooter() {
      if (this.column) {
        return this.column.filterFooter;
      }

      return true;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.popperElm = this.$el;
    this.referenceElm = this.cell;
    this.table.bodyWrapper.addEventListener('scroll', function () {
      _this2.updatePopper(); // this.showPopper = false; // 扩展 默认情况下 滚动条滚动，调整 filer-pane 显示位置，在此关闭，改为关闭 filer-pane

    });
    this.$watch('showPopper', function (value) {
      if (_this2.column) _this2.column.filterOpened = value;

      if (value) {
        _dropdown["default"].open(_this2);
      } else {
        _dropdown["default"].close(_this2);
      }
    });
  },
  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < _popup.PopupManager.zIndex) {
        this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      }
    }
  }
};
exports["default"] = _default;